// Shared CSS-variable-aware style helpers used by DraggableTable and any
// custom table that wants visual parity.
const tableStyles = {
  wrapper: {
    overflowX: 'auto' as const,
    borderRadius: 10,
    border: '1px solid var(--border-color)',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    fontSize: 14,
    background: 'var(--card-bg)',
  },
  thead: {
    background: 'var(--table-header-bg)',
    borderBottom: '2px solid var(--border-color)',
    borderLeft: '4px solid #0073ea',
  },
  th: {
    padding: '10px 16px',
    textAlign: 'left' as const,
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
    whiteSpace: 'nowrap' as const,
    color: 'var(--table-header-text)',
    userSelect: 'none' as const,
  },
  tdBase: {
    padding: '11px 16px',
    whiteSpace: 'nowrap' as const,
    color: 'var(--table-text)',
    borderBottom: '1px solid var(--border-color)',
  },
  emptyTd: {
    textAlign: 'center' as const,
    padding: '40px 16px',
    color: 'var(--text-tertiary)',
  },
  handle: {
    display: 'inline-flex' as const,
    alignItems: 'center' as const,
    padding: '2px 4px',
    borderRadius: 4,
    cursor: 'grab' as const,
    marginRight: 6,
    transition: 'background 150ms',
  },
  overlayPill: {
    padding: '10px 16px',
    background: '#6366f1',
    color: '#fff',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
    boxShadow: '0 8px 24px rgba(99,102,241,0.35)',
    display: 'flex' as const,
    alignItems: 'center' as const,
    gap: 6,
    cursor: 'grabbing' as const,
    whiteSpace: 'nowrap' as const,
  },
  toggleBtn: {
    padding: '6px 12px',
    fontSize: 13,
    border: '1px solid var(--border-color)',
    borderRadius: 6,
    background: 'var(--card-bg)',
    color: 'var(--text-primary)',
    cursor: 'pointer' as const,
    display: 'flex' as const,
    alignItems: 'center' as const,
    gap: 6,
  },
  dropdown: {
    position: 'absolute' as const,
    top: '110%',
    right: 0,
    background: 'var(--card-bg)',
    border: '1px solid var(--border-color)',
    borderRadius: 8,
    boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
    padding: '8px 0',
    zIndex: 100,
    minWidth: 160,
  },
  dropdownLabel: {
    display: 'flex' as const,
    alignItems: 'center' as const,
    gap: 8,
    padding: '6px 16px',
    cursor: 'pointer' as const,
    fontSize: 13,
    color: 'var(--text-primary)',
  },
};

export default tableStyles;
